// extracted by mini-css-extract-plugin
module.exports = {"modal-wrapper":"_1tGg38AzlOcv7Pqm0l8sJp","modal-body-content":"_308oqyWldTNU9YDJnLRfQG","body-wrapper":"_2pet9ScwDUKLLJz72IZ22M"};